import {Button, notification} from 'antd'
import runAsync from '@/script/runAsync.mjs'
import http from '@/biz/http.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonGenerateBd(props) {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const fms = []

    const collectLeafFms = n => {
        let isLeaf = 'FM' === n.data.bizNodeType

        for (const nn of n.children) {
            const {bizNodeType} = nn.data

            if ('FM' === bizNodeType) {
                isLeaf = false
                collectLeafFms(nn)
            }
        }

        if (isLeaf) {
            fms.push(n)
        }
    }

    for (const n of map.topNodes(selectedNodes)) {
        collectLeafFms(n)
    }

    const pkids = fms.map(e => e.data.pkid).filter(a => a)

    if (0 === pkids.length) {
        return null
    }

    const handleClick = async () => {
        const {prjId, sVer} = map.data

        const results = await runAsync(
            () => http.post('/archfas/fmGenBd', {pkids, prjId, sVer}),
            {action: '生成程序模块'}
        )

        const description = results.map(
            (s, i) => <p key={i}>{s}</p>
        )

        notification.open({description})
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        >
            生成程序模块
        </Button>
    )
}
